import React, { useState, useRef, useCallback, useEffect } from 'react';
// import EmojiInit from '../../images/emoji_init.png';
import TextareaAutosize from 'react-textarea-autosize';
import Modal from 'react-bootstrap/Modal';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'emoji-mart/css/emoji-mart.css';
// import { Picker } from 'emoji-mart';
import { FOLLOW_STATUS, ROLES } from '../../utils/constants';

import './style.css';

const PTextarea = ({
    caption,
    setCaption,
    placeholder = 'Create new post...',
    user,
    checkRole = true,
    calendarStatus = false,
    hasError = false,
    setHasError = () => ({}),
    isPost = false,
    categoryButton,
    ...rest
}) => {
    const [emojiPicker, setEmojiPicker] = useState(false);
    const userInformation = JSON.parse(localStorage.getItem('user'));
    const [caret, setCaret] = useState({ selectionStart: 0, selectionEnd: 0 });
    const [nearBottom, setNearBottom] = useState(false);
    const editorRef = useRef(null);
    const themeMode = (localStorage.getItem('darkmode') === 'true' ? 'dark' : 'light');

    const handleEmojiPicker = (e) => {
        var elRect = e.target.getBoundingClientRect();

        setEmojiPicker(!emojiPicker);
        if (elRect.top > 380) {
            setNearBottom(true);
        } else {
            setNearBottom(false);
        }
        setEmojiPicker(!emojiPicker);
    };

    const onEmojiClick = (emoji, e) => {
        console.log(emoji);
        let sym = emoji.unified.split('-');
        let codesArray = [];
        sym.forEach(el => codesArray.push('0x' + el));
        let theEmoji = String.fromCodePoint(...codesArray);
        console.log(theEmoji);
        setCaption((prev) => [
            prev.slice(0, caret.selectionStart),
            theEmoji,
            prev.slice(caret.selectionEnd),
        ].join(''));
        // handleEmojiPicker()
        editorRef.current.focus();
        setTimeout(() => {
            editorRef.current.selectionEnd = caret.selectionEnd + 2;
        }, 1);
    };


    const handleChange = (e) => {
        // e.persist();
        if (hasError && e.target.value) {
            setHasError(false);
        }
        setCaption(e.target.value);
    };

    useEffect(() => {
        if (!userInformation) {
            localStorage.clear();
            window.location = '/login';
        }
    }, []);

    const [createError, setCreateError] = useState(false);
    const handleCreateError = () => setCreateError(!createError);

    return (
        <>
            <Modal show={createError} onHide={handleCreateError} className="createError-modal" size="md" centered>
                <Modal.Body>
                    <h6>You cannot post content or earn money from followers until you become a creator.</h6>
                    <div className="createError-modal-btns">
                        <button className="" onClick={handleCreateError}>Ok</button>
                    </div>
                </Modal.Body>
            </Modal>
            <div className={`createpost-text-wrapper ${hasError ? 'error' : ''}`}>
                {userInformation && userInformation.role === ROLES.SU && (user ? user.subscription_status !== FOLLOW_STATUS.ACTIVE : true) && checkRole && isPost ?
                    <TextareaAutosize
                        rows={1}
                        name="post-content"
                        id="createpost-with-emoji-textarea"
                        placeholder={placeholder}
                        onChange={handleChange}
                        value={caption}
                        ref={editorRef}
                        onClick={handleCreateError}
                        minRows={1}
                        {...rest}
                    /> :
                    <TextareaAutosize
                        rows={1}
                        name="post-content"
                        id="createpost-with-emoji-textarea"
                        placeholder={placeholder}
                        onChange={handleChange}
                        value={caption}
                        ref={editorRef}
                        onClick={() => { setEmojiPicker(false); }}
                        minRows={1}
                        {...rest}
                    />
                }

                {categoryButton ? (
                    <div>
                        {categoryButton}
                    </div>
                ) : (
                    <div style={{ height: '10px' }}></div>
                )}
            </div>
        </>
    );
};

export default React.memo(PTextarea);
